import './AppFooter.css';

export function AppFooter() {
    const version = '0.5.0';

    return (
        <footer className="app-footer">
            <div className="app-footer-content">
                <span className="app-footer-version">
                    Biavent v{version}
                </span>
            </div>
        </footer>
    );
}
